import { createSlice } from "@reduxjs/toolkit";
import {
    getPendingFriendRequests,
    getSuggestedFriends,
    acceptFriendRequest,
    declineFriendRequest,
    sendFriendRequest,
    cancelFriendRequest,
    unfriendUser,
} from "./friendAction";

const initialState = {
    loading: false,
    message: 'idle',
    error: null,

    suggestLoading: false,
    suggestFriends: [],
    suggestFriendsError: null,

    requestLoading: false,
    friendRequests: [],
    requestError: null
}

const friendSlice = createSlice({
    name: 'friend',
    initialState,
    reducers: {
        toggleInvite(state, action) {
            const { userId, type } = action.payload

            const index = state.suggestFriends.findIndex(user => user.userId === userId)

            if (index !== -1) {
                if (type === 'add') {
                    state.suggestFriends[index] = {
                        ...state.suggestFriends[index],
                        friendshipStatus: "you sent a request to this user"
                    }
                } else if (type === 'remove') {
                    state.suggestFriends[index] = {
                        ...state.suggestFriends[index],
                        friendshipStatus: 'Not friends'
                    }
                } else if (type === 'accept') {
                    state.suggestFriends[index] = {
                        ...state.suggestFriends[index],
                        friendshipStatus: "User are friends"
                    }
                }
            }

        }
    },
    extraReducers: (builder) => {

        builder
            .addCase(getPendingFriendRequests.pending, (state) => {
                state.requestLoading = true
            })
            .addCase(getPendingFriendRequests.fulfilled, (state, action) => {
                state.requestLoading = false
                state.friendRequests = action.payload.map(request => ({ ...request, requestStatus: 'pending' }))
            })
            .addCase(getPendingFriendRequests.rejected, (state, action) => {
                state.requestLoading = false
                state.requestError = action.error.message
            })
        builder
            .addCase(acceptFriendRequest.fulfilled, (state, action) => {
                const { friendId } = action.meta.arg
                const index = state.friendRequests.findIndex(request => request.userId === friendId)
                if (index !== -1) state.friendRequests[index].requestStatus = 'accepted'
            })
            .addCase(declineFriendRequest.fulfilled, (state, action) => {
                const { friendId } = action.meta.arg
                const index = state.friendRequests.findIndex(request => request.userId === friendId)
                if (index !== -1) state.friendRequests[index].requestStatus = 'declined'
            })
            .addCase(sendFriendRequest.fulfilled, (state, action) => {
                const { friendId } = action.meta.arg
                const index = state.friendRequests.findIndex(request => request.userId === friendId)
                if (index !== -1) state.friendRequests[index].requestStatus = 'request-sent'
            })
            .addCase(cancelFriendRequest.fulfilled, (state, action) => {
                const { friendId } = action.meta.arg
                state.friendRequests = state.friendRequests.filter(request => request.userId !== friendId)
            })
            .addCase(unfriendUser.fulfilled, (state, action) => {
                const { friendId } = action.meta.arg
                state.friendRequests = state.friendRequests.filter(request => request.userId !== friendId)
            })

        builder
            .addCase(getSuggestedFriends.pending, (state) => {
                state.suggestFriendsError = null
                state.suggestLoading = true
            })
            .addCase(getSuggestedFriends.fulfilled, (state, action) => {
                state.suggestLoading = false
                state.suggestFriends = action.payload
            })
            .addCase(getSuggestedFriends.rejected, (state, action) => {
                state.suggestLoading = false
                state.suggestFriendsError = action.error.message
            })
    }
})

export const { toggleInvite } = friendSlice.actions
export default friendSlice.reducer;